import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Button, Modal, TextArea } from 'semantic-ui-react'
import { FormValidation, Field, PrefillTextModal } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { updateResult } from '../../common/results/actions'
import { loadActiveLocations } from '../../common/locations/actions'
import {
  validateUpdatePCOperator,
  validateUpdateInstructorWeb,
  validateUpdatePsychologist,
  validateUpdateAdminWeb,
  validateUpdateSupervisorWeb,
} from '../../common/results/validations'
import { roles, resultTypes, courseTypesFormated } from '../../common/config'

import './Result.scss'

const { Row, Column } = Grid

const pointOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9].map(points => ({ value: points, text: points }))
const resultOptions = Object.keys(resultTypes).map(key => ({ value: key, text: resultTypes[key] }))
const courseTypeOptions = Object.keys(courseTypesFormated).map(
  key => ({ value: key, text: courseTypesFormated[key].name }),
)

const setDefaultValueIfEqual = (
  fields,
  fieldToCheck,
  comparisonValue,
  fieldToFill,
  defaultValue,
) => {
  if (fields[fieldToFill].value) return
  const currentValue = fields[fieldToCheck].value
  if (currentValue === comparisonValue) {
    // eslint-disable-line
    fields[fieldToFill].onChange({ value: defaultValue })
  }
}

const getPoints = field => {
  if (field && typeof field.value !== 'undefined') return field.value
  if (typeof field !== 'undefined') return field
  return 0
}

const getRiskFactor = fields => {
  const {
    trafficRulesPoints,
    drivingEconomyPoints,
    drivingTechniquePoints,
    defensiveDrivingPoints,
  } = fields
  const trp = getPoints(trafficRulesPoints)
  const dep = getPoints(drivingEconomyPoints)
  const dtp = getPoints(drivingTechniquePoints)
  const ddp = getPoints(defensiveDrivingPoints)
  return (trp + dep + dtp + ddp) / 4
}

const getBirthDate = (date) => {
  var m = moment('' + date);
  if (m.isValid()) {
    if (m.isAfter('1901-05-01')) { /* 2. kvetna 1901 - Chiyo Miyako */
      return ' nar. ' + m.format('D.M.YYYY') + ' (' + moment().diff(m, 'years') + ')'
    } else {
      return ''
    }
  } else {
    return ''
  }
}

class Result extends React.Component {
  constructor(props) {
    super(props)
    this.openNote = this.openNote.bind(this)
    this.closeNote = this.closeNote.bind(this)
    this.clearNote = this.clearNote.bind(this)
    this.state = {
      openPrefillResult: false,
      openNote: null,
      openField: null,
      fieldValue: '',
      fieldLabel: '',
      safetyFactor: 0,
      drivingEconomyPoints: 0,
      drivingTechniquePoints: 0,
      defensiveDrivingPoints: 0,
      trafficRulesPoints: 0,
    }
  }

  componentWillMount() {
    this.getPermissions()
	this.props.loadActiveLocations({ sort: 'nameSort' })
    const fields = this.props.fields
    if (this.props.viewer.role === 'SUPERVISOR') {
      const safetyFactor = fields.safetyFactor.value || getRiskFactor(fields)
      if (fields.safetyFactor.value !== safetyFactor) {
        fields.safetyFactor.onChange({ value: safetyFactor })
      }
      this.setState({
        safetyFactor: Number(safetyFactor || 0),
        drivingEconomyPoints: fields.drivingEconomyPoints.value,
        drivingTechniquePoints: fields.drivingTechniquePoints.value,
        defensiveDrivingPoints: fields.defensiveDrivingPoints.value,
        trafficRulesPoints: fields.trafficRulesPoints.value,
      })
    }
    setDefaultValueIfEqual(fields, 'drivingEconomyPoints', 9, 'drivingEconomyMistakes', 'Bez závad.')
    setDefaultValueIfEqual(
      fields,
      'drivingTechniquePoints',
      9,
      'drivingTechniqueMistakes',
      'Bez závad.',
    )
    setDefaultValueIfEqual(
      fields,
      'defensiveDrivingPoints',
      9,
      'defensiveDrivingMistakes',
      'Bez závad.',
    )
    setDefaultValueIfEqual(fields, 'trafficRulesPoints', 9, 'trafficRulesMistakes', 'Bez závad.')
  }

  componentWillReceiveProps(newProps) {
    const viewer = newProps.viewer

    if (viewer.role === 'SUPERVISOR' && newProps.result.testedBy) {
      const newFields = Object.assign({}, newProps.fields)
      const oldSafetyFactor = this.state.safetyFactor || 0
      const newSafetyFactor = newFields.safetyFactor.value || 0

      const newCountedSafetyFactor = getRiskFactor(newFields)
      if (!newCountedSafetyFactor) return

      const oldCountedSafetyFactor = getRiskFactor(this.state)

      if (newCountedSafetyFactor !== oldCountedSafetyFactor) {
        newFields.safetyFactor.onChange({ value: Number(newCountedSafetyFactor) })
        this.setState({
          safetyFactor: Number(newCountedSafetyFactor),
          drivingEconomyPoints: newFields.drivingEconomyPoints.value,
          drivingTechniquePoints: newFields.drivingTechniquePoints.value,
          defensiveDrivingPoints: newFields.defensiveDrivingPoints.value,
          trafficRulesPoints: newFields.trafficRulesPoints.value,
        })
      } else if (
        oldCountedSafetyFactor === newCountedSafetyFactor &&
        oldSafetyFactor !== newSafetyFactor
      ) {
        newFields.safetyFactor.onChange({ value: Number(newSafetyFactor) })
        this.setState({ safetyFactor: Number(newSafetyFactor) })
      }
    }
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  getPermissions() {
    const { viewer: { role }, result } = this.props
    const { PSYCHOLOGIST, PC_OPERATOR, FLEET_MANAGER, ADMIN, INSTRUCTOR, SUPERVISOR } = roles

    const isIns = role === INSTRUCTOR
    const isFM = role === FLEET_MANAGER
    const isSV = role === SUPERVISOR
    let editable = !(isFM || (isIns && result.closedByInstructor))
    if (
      isSV &&
      (!result.closedByInstructor ||
        (result.courseType === 'AUDIT' &&
          (!result.psychologicalReport || typeof result.trafficRulesPoints === 'undefined')))
    ) {
      editable = false
    }

    const canViewTrafficRules = [PC_OPERATOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewPsychologicalReport =
      [PSYCHOLOGIST, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewDrivingLicence =
      [INSTRUCTOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewCrashes = [INSTRUCTOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewExperience = [INSTRUCTOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewEvaluation = [INSTRUCTOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewSummary = [INSTRUCTOR, FLEET_MANAGER, ADMIN, SUPERVISOR].indexOf(role) !== -1

    const canViewConclusion = [FLEET_MANAGER, SUPERVISOR].indexOf(role) !== -1

    this.setState({
      editable,
      canViewTrafficRules,
      canViewPsychologicalReport,
      canViewDrivingLicence,
      canViewCrashes,
      canViewExperience,
      canViewEvaluation,
      canViewSummary,
      canViewConclusion,
    })
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, result, updateResult } = this.props
    const values = Object.assign({}, fields.$values(), {
      _id: result._id,
      trafficRulesNotes: result.trafficRulesNotes,
      drivingTechniqueNotes: result.drivingTechniqueNotes,
      defensiveDrivingNotes: result.defensiveDrivingNotes,
      drivingEconomyNotes: result.drivingEconomyNotes,
      driverSummaryNote: result.driverSummaryNote,
      recommendationForDriverNote: result.recommendationForDriverNote,
      recommendationForCompanyNote: result.recommendationForCompanyNote,
      commentNote: result.commentNote,
      platform: 'web',
    })

    if ((await submit(values, updateResult)) !== false) {
      fields.$reset()
    }
  }

  openNote(note, field, fieldLabel) {
    this.setState({
      openNote: note,
      openField: field,
      fieldValue: field.value,
      fieldLabel,
    })
  }

  closeNote() {
    const { fieldValue, openField } = this.state
    openField.onChange({ value: fieldValue })
    this.clearNote()
  }

  clearNote() {
    this.setState({ openNote: null, openField: null, fieldValue: '', fieldLabel: '' })
  }

  render() {
    const {
      fields,
      result,
      viewer,
      errors,
      submitting,
      submitSuccessfull,
      errorMessage,
      locationOptions,
    } = this.props

    const {
      openNote,
      fieldValue,
      fieldLabel,
      editable,
      canViewTrafficRules,
      canViewPsychologicalReport,
      canViewDrivingLicence,
      canViewCrashes,
      canViewExperience,
      canViewEvaluation,
      canViewSummary,
      canViewConclusion,
    } = this.state

    if (submitSuccessfull) return <Redirect to="/results" />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field && fieldData[error.detail.field]) {
        fieldData[error.detail.field].error = error.message
      }
    })

    if (!editable) {
      Object.keys(fieldData).forEach(key => {
        fieldData[key].disabled = true
      })
    }

    const risk = getRiskFactor(fieldData)
	const birthText = getBirthDate(result.driverBirthdate)

    return (
      <Form loading={submitting} size="big" className="result-form">
        <Modal open={!!openNote} onClose={this.closeNote} closeIcon>
          <Modal.Header>{fieldLabel}</Modal.Header>
          <Modal.Content>
            <Grid>
              <Row columns={editable ? 2 : 1}>
                {editable &&
                  <Column width={6}>
                    <Form size="big" style={{ height: '100%' }}>
                      <TextArea
                        value={fieldValue}
                        onChange={(e, event) => this.setState({ fieldValue: event.value })}
                        disabled={!editable}
                        style={{ height: '100%' }}
                        placeholder={fieldLabel}
                      />
                    </Form>
                  </Column>}
                <Column width={editable ? 10 : 16}>
                  {openNote && <img src={openNote.path} alt="note" />}
                </Column>
              </Row>
            </Grid>
          </Modal.Content>
          {editable &&
            <Modal.Actions>
              <Button color="red" size="large" onClick={this.closeNote}>
                Uložit
              </Button>
              <Button basic size="large" onClick={this.clearNote}>
                Zrušit změny
              </Button>
            </Modal.Actions>}
        </Modal>
        <Grid>
          <Row columns={1}>
            <Column>
              <Header as="h2">{`Základní údaje ${result.driverFirstName} ${result.driverLastName}`}</Header>
            </Column>
          </Row>
          {birthText && birthText.length > 0 &&
		  <Row columns={1}>
            <Column>
              <Header as="h3">{`${birthText}`}</Header>
            </Column>
          </Row>}
          <Row>
            <Column>Dopravce: {result.companyName}</Column>
          </Row>
          <Field label="Lokace" type="select" options={locationOptions} {...fieldData.location} required />
          <Field label="Akce" type="select" options={courseTypeOptions} {...fieldData.courseType} required />
          <Field label="Datum testu" type="date" {...fieldData.testedAt} required />
        </Grid>

        {canViewTrafficRules &&
          result.courseType === 'AUDIT' &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Test z pravidel provozu na poz. komunikacích <br />
                  {viewer.role === 'SUPERVISOR' &&
                    result.trafficRulesTestedBy &&
                    <small>({result.trafficRulesTestedBy.name})</small>}
                </Header>
              </Column>
            </Row>
            <Field
              label="Dosaženo bodů"
              type="number"
              className="small"
              min={0}
              max={50}
              {...fieldData.trafficRulesTestPoints}
              onChange={({ value }) => {
                const points = Number(value)
                if (points < 43) {
                  fieldData.trafficRulesTestResult.onChange({ value: 'N (min 43 z 50 bodů)' })
                } else {
                  fieldData.trafficRulesTestResult.onChange({ value: 'P (min. 43 z 50 bodů)' })
                }
                fieldData.trafficRulesTestPoints.onChange({ value })
              }}
            />
            <Field label="Výsledek" {...fieldData.trafficRulesTestResult} />
          </Grid>}

        {canViewPsychologicalReport &&
          result.courseType === 'AUDIT' &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Dopravně psychologický pohovor <br />
                  {viewer.role === 'SUPERVISOR' &&
                    result.psychologicalReportBy &&
                    <small>({result.psychologicalReportBy.name})</small>}
                </Header>
              </Column>
            </Row>
            <Field type="textarea" className="large" {...fieldData.psychologicalReport} />
          </Grid>}

        {canViewDrivingLicence &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Řidičský průkaz
                </Header>
              </Column>
            </Row>
            <Field label="Předložen" type="checkbox" {...fieldData.drivingLicenceProvided} />
            <Field label="Expirace ŘP" type="date" {...fieldData.drivingLicenceExpireDate} />
            <Field label="Poznámka k ŘP" type="textarea" {...fieldData.drivingLicenceNote} />
          </Grid>}

        {canViewExperience &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Praxe v řízení
                </Header>
              </Column>
            </Row>
            <Field
              label="Celkem"
              type="number"
              className="small"
              min={0}
              after={<span className="years">[roky]</span>}
              {...fieldData.experienceYearsCount}
            />
            <Field
              label="Druh vozidla"
              type="number"
              className="small"
              min={0}
              after={<span className="years">[roky]</span>}
              {...fieldData.workExperienceYearsCount}
              tooltip="Praxe v řízení na druhu vozidla, které se vztahuje k zaměstnání řidiče"
            />
          </Grid>}

        {canViewCrashes &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Nehody - zaviněné
                </Header>
              </Column>
            </Row>
            <Field
              label="Počet"
              type="number"
              className="small"
              min={0}
              {...fieldData.causedCrashesCount}
            />
            <Field
              label="Popis"
              type="textarea"
              className="small"
              {...fieldData.causedCrashesDescription}
            />
          </Grid>}

        {canViewCrashes &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Nehody - nezaviněné
                </Header>
              </Column>
            </Row>
            <Field
              label="Počet"
              type="number"
              min={0}
              className="small"
              {...fieldData.notCausedCrashesCount}
            />
            <Field
              label="Popis"
              type="textarea"
              className="small"
              {...fieldData.notCausedCrashesDescription}
            />
          </Grid>}

        {canViewEvaluation &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Hodnocení jízdy <br />
                  {viewer.role === 'SUPERVISOR' &&
                    result.testedBy &&
                    <small>({result.testedBy.name})</small>}
                </Header>
              </Column>
            </Row>

            <Row>
              <Column>
                <Header as="h3">
                  Pravidla provozu na poz. komunikacích
                </Header>
              </Column>
            </Row>
            <Field
              label="Závady, chyby, nedostatky"
              type="textarea"
              {...fieldData.trafficRulesMistakes}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.trafficRulesNotes.map(note => (
                  <i
                    className="daicon daicon-Image"
                    key={note.path}
                    onClick={() =>
                      this.openNote(
                        note,
                        fieldData.trafficRulesMistakes,
                        'Pravidla provozu na poz. komunikacích',
                      )}
                  />
                ))}
            </Field>
            <Field
              className="points"
              label="Hodnocení"
              type="switch"
              options={pointOptions}
              {...fieldData.trafficRulesPoints}
              onChange={({ value }) => {
                if (value === 9 && !fieldData.trafficRulesMistakes.value) {
                  fieldData.trafficRulesMistakes.onChange({ value: 'Bez závad.' })
                }
                fieldData.trafficRulesPoints.onChange({ value })
              }}
            />

            <Row>
              <Column>
                <Header as="h3">
                  Technika jízdy
                </Header>
              </Column>
            </Row>
            <Field
              label="Závady, chyby, nedostatky"
              type="textarea"
              {...fieldData.drivingTechniqueMistakes}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.drivingTechniqueNotes.map(note => (
                  <i
                    className="daicon daicon-Image"
                    key={note.path}
                    onClick={() =>
                      this.openNote(note, fieldData.drivingTechniqueMistakes, 'Technika jízdy')}
                  />
                ))}
            </Field>
            <Field
              className="points"
              label="Hodnocení"
              type="switch"
              options={pointOptions}
              {...fieldData.drivingTechniquePoints}
              onChange={({ value }) => {
                if (value === 9 && !fieldData.drivingTechniqueMistakes.value) {
                  fieldData.drivingTechniqueMistakes.onChange({ value: 'Bez závad.' })
                }
                fieldData.drivingTechniquePoints.onChange({ value })
              }}
            />

            <Row>
              <Column>
                <Header as="h3">
                  Defenzivní způsob jízdy
                </Header>
              </Column>
            </Row>

            <Field
              label="Závady, chyby, nedostatky"
              type="textarea"
              {...fieldData.defensiveDrivingMistakes}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.defensiveDrivingNotes.map(note => (
                  <i
                    className="daicon daicon-Image"
                    key={note.path}
                    onClick={() =>
                      this.openNote(
                        note,
                        fieldData.defensiveDrivingMistakes,
                        'Defenzivní způsob jízdy',
                      )}
                  />
                ))}
            </Field>
            <Field
              className="points"
              label="Hodnocení"
              type="switch"
              options={pointOptions}
              {...fieldData.defensiveDrivingPoints}
              onChange={({ value }) => {
                if (value === 9 && !fieldData.defensiveDrivingMistakes.value) {
                  fieldData.defensiveDrivingMistakes.onChange({ value: 'Bez závad.' })
                }
                fieldData.defensiveDrivingPoints.onChange({ value })
              }}
            />

            <Row>
              <Column>
                <Header as="h3">
                  Ekonomika jízdy
                </Header>
              </Column>
            </Row>
            <Field
              label="Závady, chyby, nedostatky"
              type="textarea"
              {...fieldData.drivingEconomyMistakes}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.drivingEconomyNotes.map(note => (
                  <i
                    className="daicon daicon-Image"
                    key={note.path}
                    onClick={() =>
                      this.openNote(note, fieldData.drivingEconomyMistakes, 'Ekonomika jízdy')}
                  />
                ))}
            </Field>
            <Field
              className="points"
              label="Hodnocení"
              type="switch"
              options={pointOptions}
              {...fieldData.drivingEconomyPoints}
              onChange={({ value }) => {
                if (value === 9 && !fieldData.drivingEconomyMistakes.value) {
                  fieldData.drivingEconomyMistakes.onChange({ value: 'Bez závad.' })
                }
                fieldData.drivingEconomyPoints.onChange({ value })
              }}
            />

            <Row>
              <Column>
                <Header as="h3">Komentář</Header>
              </Column>
            </Row>
            <Field type="textarea" className="large" {...fieldData.comment}>
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.commentNote &&
                <i
                  className="daicon daicon-Image"
                  key={result.commentNote}
                  onClick={() =>
                    this.openNote({ path: result.commentNote }, fieldData.comment, 'Komentář')}
                />}
            </Field>
          </Grid>}

        {canViewSummary &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Shrnutí
                </Header>
              </Column>
            </Row>
            <Field label="Profil řidiče" type="textarea" {...fieldData.driverSummary}>
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.driverSummaryNote &&
                <i
                  className="daicon daicon-Image"
                  key={result.driverSummaryNote}
                  onClick={() =>
                    this.openNote(
                      { path: result.driverSummaryNote },
                      fieldData.driverSummary,
                      'Profil řidiče',
                    )}
                />}
            </Field>
            <Field
              label="Doporučení pro řidiče"
              type="textarea"
              {...fieldData.recommendationForDriver}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.recommendationForDriverNote &&
                <i
                  className="daicon daicon-Image"
                  key={result.recommendationForDriverNote}
                  onClick={() =>
                    this.openNote(
                      { path: result.recommendationForDriverNote },
                      fieldData.recommendationForDriver,
                      'Doporučení pro řidiče',
                    )}
                />}
            </Field>
            <Field
              label="Doporučení pro společnost"
              type="textarea"
              {...fieldData.recommendationForCompany}
            >
              {result.testedBy &&
                viewer._id === result.testedBy._id &&
                result.recommendationForCompanyNote &&
                <i
                  className="daicon daicon-Image"
                  key={result.recommendationForCompanyNote}
                  onClick={() =>
                    this.openNote(
                      { path: result.recommendationForCompanyNote },
                      fieldData.recommendationForCompany,
                      'Doporučení pro společnost',
                    )}
                />}
            </Field>
            {[roles.INSTRUCTOR].indexOf(viewer.role) !== -1 &&
              <Field label="Uzavřít hodnocení" type="checkbox" {...fieldData.closedByInstructor} />}
            {[roles.ADMIN, roles.SUPERVISOR].indexOf(viewer.role) !== -1 &&
              <Field label="Uzavřeno instruktorem" type="checkbox" {...fieldData.closedByInstructor} />}
          </Grid>}

        {canViewConclusion &&
          <Grid>
            <Row>
              <Column>
                <Header as="h2">
                  Celkové shrnutí
                </Header>
              </Column>
            </Row>
            <Field type="textarea" className="large" {...fieldData.summary} />

            <PrefillTextModal
              onClose={() => this.setState({ openPrefillResult: false })}
              field={fieldData.summary}
              visible={this.state.openPrefillResult}
              isFemale={result.driver.gender === 'FEMALE'}
            />

            {viewer.role !== roles.FLEET_MANAGER &&
              <Row columns={3}>
                <Column>
                  <a onClick={() => this.setState({ openPrefillResult: true })}>
                    Vložit předpřipravený text
                  </a>
                </Column>
                <Column />
                <Column />
              </Row>}

            <Field
              label="Faktor bezpečnosti"
              type="number"
              className="small"
              step="0.05"
              min={1}
              max={9}
              {...fieldData.safetyFactor}
              before={
                viewer.role !== 'FLEET_MANAGER'
                  ? <span className="safety-factor">{String(risk).replace('.', ',')}</span>
                  : null
              }
              tooltip={
                <span>
                  Rozsah 1 až 9.<br />
                  Čím nižší číslo, tím vyšší pravděpodobnost,
                  že se řidič stane účastníkem dopravní nehody.
                </span>
              }
            />
            <Field
              label="Výrok"
              type="switch"
              options={resultOptions}
              {...fieldData.result}
              className="result-switch"
            />
            {viewer.role === 'SUPERVISOR' &&
              <Field label="Uzavřít" type="checkbox" {...fieldData.closedBySupervisor} />}
          </Grid>}

        {errorMessage}

        {editable &&
          <Grid>
            <Row>
              <Column>
                <Button type="submit" onClick={e => this.submit(e)}>Uložit</Button>
              </Column>
            </Row>
          </Grid>}

      </Form>
    )
  }
}

Result.defaultProps = {
  result: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

Result.propTypes = {
  errorMessage: React.PropTypes.any,
  errors: React.PropTypes.array,
  fields: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  result: React.PropTypes.object,
  updateResult: React.PropTypes.func.isRequired,
  loadActiveLocations: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

Result = fields(Result, {
  path: 'ResultForm',
  fields: [
    'location',
	'courseType',
	'testedAt',
    'trafficRulesTestPoints',
    'trafficRulesTestResult',
    'psychologicalReport',
    'drivingLicenceProvided',
    'drivingLicenceExpireDate',
    'drivingLicenceNote',
    'experienceYearsCount',
    'workExperienceYearsCount',
    'causedCrashesCount',
    'causedCrashesDescription',
    'notCausedCrashesCount',
    'notCausedCrashesDescription',
    'trafficRulesMistakes',
    'trafficRulesPoints',
    'defensiveDrivingMistakes',
    'defensiveDrivingPoints',
    'drivingTechniqueMistakes',
    'drivingTechniquePoints',
    'drivingEconomyMistakes',
    'drivingEconomyPoints',
    'driverSummary',
    'recommendationForDriver',
    'recommendationForCompany',
    'comment',
    'summary',
    'safetyFactor',
    'result',
    'closedByInstructor',
    'closedBySupervisor',
  ],
  getInitialState: props => {
    const { result } = props
    if (result) {
      const resultObject = result.toJS()
      if (!resultObject.safetyFactor) {
        resultObject.safetyFactor =
          (result.trafficRulesPoints +
            result.drivingEconomyPoints +
            result.drivingTechniquePoints +
            result.defensiveDrivingPoints) /
          4
      }
      return resultObject
    }
    return {}
  },
})

Result = FormValidation(Result, props => {
  const { viewer } = props
  let submissionValidation
  switch (viewer.role) {
    case roles.PC_OPERATOR:
      submissionValidation = validateUpdatePCOperator
      break
    case roles.INSTRUCTOR:
      submissionValidation = validateUpdateInstructorWeb
      break
    case roles.PSYCHOLOGIST:
      submissionValidation = validateUpdatePsychologist
      break
    case roles.ADMIN:
      submissionValidation = validateUpdateAdminWeb
      break
    case roles.SUPERVISOR:
      submissionValidation = validateUpdateSupervisorWeb
      break
    // no default
  }
  return { submissionValidation }
})

export default connect((state) => ({
  locationOptions: state.locations.all.map(l => ({ value: l._id, text: l.name })).toArray(),
}), { updateResult, loadActiveLocations })(Result)



// WEBPACK FOOTER //
// ./src/browser/forms/Result.js